(function () {
  function initCouponScript() {
    if (window._discountCouponMsgObserver) {
      window._discountCouponMsgObserver.disconnect();
    }
    window._discountCouponMsgObserver = new MutationObserver(() => {
      if (window._lastDiscountCouponMsg) {
        const msgEl = document.querySelector(".discount-coupon__message");
        if (msgEl) {
          setTimeout(() => {
            showMsg(
              window._lastDiscountCouponMsg.message,
              window._lastDiscountCouponMsg.type,
            );
            window._lastDiscountCouponMsg = null;
          }, 50);
        }
      }
    });
    window._discountCouponMsgObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
    if (window._lastDiscountCouponMsg) {
      setTimeout(() => {
        showMsg(
          window._lastDiscountCouponMsg.message,
          window._lastDiscountCouponMsg.type,
        );
        window._lastDiscountCouponMsg = null;
      }, 100);
    }
    const form = document.getElementById("discount-coupon-form");
    const input = document.getElementById("discount-coupon-input");
    const btn = form ? form.querySelector(".discount-coupon__button") : null;
    const msg = form
      ? form.parentElement.querySelector(".discount-coupon__message")
      : null;

    const isCartPage = window.location.pathname === "/cart";
    const isCartDrawer = !!document.querySelector("#CartDrawer");

    async function updateCartSummary() {
      try {
        const res = await fetch("/cart.js");
        const data = await res.json();

        if (data.item_count === 0) {
          await removeCoupon();
          removeDiscountElements();
          return;
        }

        const drawerTotalEl = document.querySelector(
          "#CartDrawer .totals__total-value",
        );
        if (drawerTotalEl) {
          drawerTotalEl.textContent = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(data.total_price / 100);
        }

        const cartTotalEl = document.querySelector(".cart-total-value");
        if (cartTotalEl) {
          cartTotalEl.textContent = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(data.total_price / 100);
        }

        const pageTotalEls = document.querySelectorAll(".totals__total-value");
        pageTotalEls.forEach((el) => {
          if (el.closest("#main-cart-footer") || el.closest(".cart__footer")) {
            el.textContent = new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(data.total_price / 100);
          }
        });

        const discountEl = document.querySelector(".cart-discount-value");
        if (discountEl) {
          let discount = data.original_total_price - data.total_price;
          discountEl.textContent =
            discount > 0
              ? "- " +
                new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(discount / 100)
              : "";
        }

        const discountTotalEl = document.querySelector(
          ".totals__total-value--discount",
        );
        if (discountTotalEl) {
          const comparedPrice = parseInt(
            discountTotalEl.getAttribute("data-compared-price") || "0",
          );
          let totalDiscount = comparedPrice - data.total_price;
          const discountContainer = discountTotalEl.closest(".totals");
          if (totalDiscount > 0) {
            discountTotalEl.textContent = new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(totalDiscount / 100);
            if (discountContainer) discountContainer.style.display = "";
          } else {
            discountTotalEl.textContent = "";
            if (discountContainer) discountContainer.style.display = "none";
          }
        }
      } catch (e) {}
    }

    window.updateCartSummary = updateCartSummary;

    async function reloadCartDrawer() {
      try {
        const drawer = document.querySelector("#CartDrawer");
        if (!drawer) return;

        const couponDetails = drawer.querySelector(".discount-coupon");
        const couponWasOpen =
          couponDetails && couponDetails.hasAttribute("open");

        const res = await fetch(
          window.location.pathname + "?section_id=cart-drawer",
        );
        const html = await res.text();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const newDrawer = tempDiv.querySelector("#CartDrawer");
        if (newDrawer) {
          drawer.innerHTML = newDrawer.innerHTML;
          if (couponWasOpen) {
            const restoredDetails = drawer.querySelector(".discount-coupon");
            if (restoredDetails) restoredDetails.setAttribute("open", "");
          }

          await fetchAppliedCoupon();
          initCouponScript();

          if (window.updateProgressBar) {
            window.updateProgressBar();
          }
          await updateCartSummary();
        }
      } catch (e) {}
    }

    async function reloadCartPage() {
      try {
        if (!isCartPage) return;

        const sectionsToReload = [
          { id: "main-cart-items", selector: ".js-contents" },
          { id: "main-cart-footer", selector: ".js-contents" },
        ];

        for (const { id, selector } of sectionsToReload) {
          const section = document.getElementById(id);
          if (!section) continue;

          const sectionId = section.dataset.id;
          if (!sectionId) continue;

          const currentCouponDetails = section.querySelector(
            ".discount-coupon details",
          );
          const wasOpen =
            currentCouponDetails && currentCouponDetails.hasAttribute("open");

          const res = await fetch(
            `${window.location.pathname}?section_id=${sectionId}`,
          );
          const html = await res.text();
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;
          const newSection = tempDiv.querySelector(`#${id}`);

          if (newSection) {
            const elementToReplace = section.querySelector(selector) || section;
            const newElementToReplace =
              newSection.querySelector(selector) || newSection;

            if (elementToReplace && newElementToReplace) {
              elementToReplace.innerHTML = newElementToReplace.innerHTML;
            } else {
              section.innerHTML = newSection.innerHTML;
            }

            if (wasOpen) {
              const restoredDetails = section.querySelector(
                ".discount-coupon details",
              );
              if (restoredDetails) restoredDetails.setAttribute("open", "");
            }

            await fetchAppliedCoupon();
            initCouponScript();
          }
        }
      } catch (e) {}
    }

    async function applyCoupon() {
      const inputEl = document.getElementById("discount-coupon-input");
      const code = inputEl ? inputEl.value.trim().toUpperCase() : "";
      inputEl.value = "";
      if (!code) {
        showMsg("Por favor, digite um código de cupom.", "error");
        input.value = "";
        return;
      }

      const existingCoupons = await getCurrentCoupons();
      if (existingCoupons.includes(code.toUpperCase())) {
        showMsg("Este cupom já foi aplicado.", "error");
        input.value = "";
        return;
      }

      btn.disabled = true;
      btn.classList.add("loading");

      try {
        const cartResBefore = await fetch("/cart.js");
        const cartDataBefore = await cartResBefore.json();
        const previousApplicable = (cartDataBefore.discount_codes || [])
          .filter((dc) => dc.applicable)
          .map((dc) => dc.code);

        const allCoupons = [...existingCoupons, code];
        await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ discount: allCoupons.join(",") }),
        });

        const finalRes = await fetch("/cart.js");
        const finalData = await finalRes.json();
        const finalCoupons = finalData.discount_codes || [];

        const previousLost = previousApplicable.filter(
          (prevCode) =>
            !finalCoupons.some(
              (dc) =>
                dc.code.toUpperCase() === prevCode.toUpperCase() &&
                dc.applicable,
            ),
        );

        if (previousApplicable.length > 0 && previousLost.length > 0) {
          await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ discount: "" }),
          });
          if (previousApplicable.length > 0) {
            await fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ discount: previousApplicable.join(",") }),
            });
          }
          showMsg(
            "O novo cupom não é compatível com os cupons já aplicados.",
            "error",
          );
          input.value = "";
          await fetchAppliedCoupon();
          await updateCartSummary();
          btn.disabled = false;
          btn.classList.remove("loading");
          return;
        }

        if (
          finalCoupons.some(
            (dc) =>
              dc.code.toUpperCase() === code.toUpperCase() && !dc.applicable,
          )
        ) {
          showMsg("Cupom inválido ou não aplicável ao seu pedido.", "error");
          input.value = "";
          await fetchAppliedCoupon();
          await updateCartSummary();
          btn.disabled = false;
          btn.classList.remove("loading");
          return;
        }

        const applicableCoupons = finalCoupons
          .filter((dc) => dc.applicable)
          .map((dc) => dc.code);
        if (applicableCoupons.length === 0) {
          showMsg("Cupom inválido ou expirado.", "error");
          input.value = "";
          await fetchAppliedCoupon();
          await updateCartSummary();
          btn.disabled = false;
          btn.classList.remove("loading");
          return;
        }

        input.value = "";
        await fetchAppliedCoupon();
        await updateCartSummary();

        if (isCartDrawer) {
          await reloadCartDrawer();
        }

        showMsg("Cupom aplicado com sucesso!", "success");
      } catch (err) {
        showMsg("Erro ao aplicar o cupom.", "error");
      }

      input.value = "";
      btn.disabled = false;
      btn.classList.remove("loading");
    }

    async function getCurrentCoupons() {
      try {
        const res = await fetch("/cart.js");
        const data = await res.json();
        const discountCodes = data.discount_codes || [];
        return discountCodes.map((dc) => dc.code.toUpperCase());
      } catch (e) {
        console.error("Error getting current coupons:", e);
        return [];
      }
    }

    async function removeCoupon(couponCode) {
      if (!couponCode) return;

      console.log("Starting remove for coupon:", couponCode);

      try {
        const currentCoupons = await getCurrentCoupons();
        console.log("Current coupons before remove:", currentCoupons);

        const remainingCoupons = currentCoupons.filter(
          (code) =>
            code.trim().toUpperCase() !== couponCode.trim().toUpperCase(),
        );
        console.log("Remaining coupons after filter:", remainingCoupons);

        console.log("Clearing all coupons...");
        await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ discount: "" }),
        });

        if (remainingCoupons.length > 0) {
          const restoreString = remainingCoupons.join(",");
          console.log("Reapplying remaining coupons:", restoreString);
          await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ discount: restoreString }),
          });
        }

        showMsg("Cupom removido.", "success");

        removeDiscountElements();

        setTimeout(async () => {
          await fetchAppliedCoupon();
          await updateCartSummary();
          if (isCartDrawer) {
            await reloadCartDrawer();
          }
        }, 500);
      } catch (e) {
        showMsg("Erro ao remover o cupom.", "error");
      }
    }

    window.removeCoupon = removeCoupon;

    function removeDiscountElements() {
      const discountElements = document.querySelectorAll(
        ".discounts__discount--end, .discounts__discount--position",
      );
      discountElements.forEach((el) => el.remove());
    }

    function createCouponElement(code) {
      const couponEl = document.createElement("div");
      couponEl.className = "cart-coupon-applied";
      couponEl.setAttribute("data-discount-code", code);

      const textEl = document.createElement("span");
      textEl.className = "cart-coupon-applied-text";
      textEl.textContent = code;

      const removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "cart-coupon-remove";
      removeBtn.setAttribute("aria-label", "Remover cupom");
      removeBtn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="var(--icon-stroke-width)" stroke="currentColor" class="icon icon-close"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>';

      removeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        removeBtn.disabled = true;
        removeBtn.classList.add("loading");
        removeCoupon(code).finally(() => {
          removeBtn.disabled = false;
          removeBtn.classList.remove("loading");
        });
      });

      couponEl.appendChild(textEl);
      couponEl.appendChild(removeBtn);

      return couponEl;
    }

    async function fetchAppliedCoupon() {
      try {
        const list = document.querySelector(".discount-coupon__list");
        if (!list) return;

        const res = await fetch("/cart.js");
        const data = await res.json();
        const discountCodes = data.discount_codes || [];
        const cartLevelDiscounts = data.cart_level_discount_applications || [];

        const applicableCodes = discountCodes
          .filter((dc) => dc.applicable)
          .map((dc) => dc.code.toUpperCase());
        const allCodes = discountCodes.map((dc) => dc.code.toUpperCase());

        if (applicableCodes.length !== allCodes.length) {
          await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ discount: applicableCodes.join(",") }),
          });
        }

        list.innerHTML = "";
        applicableCodes.forEach((code) => {
          const couponEl = createCouponElement(code);
          list.appendChild(couponEl);
        });

        // If no applicable coupons, ensure discount elements are removed
        if (applicableCodes.length === 0) {
          removeDiscountElements();
        }

        console.log("Cart data:", data);

        updateFreeShippingBar(data);
      } catch (e) {
        console.error("Error fetching applied coupons:", e);
      }
    }

    function updateFreeShippingBar(cartData) {
      const freeShippingBars = document.querySelectorAll(
        "free-shipping-progress-bar",
      );
      // Verifica se há cupom com 'FRETE' no nome
      let hasFreteCoupon = false;
      if (cartData && cartData.discount_codes) {
        hasFreteCoupon = cartData.discount_codes.some(
          (dc) =>
            dc.applicable && dc.code && dc.code.toUpperCase().includes("FRETE"),
        );
      }
      freeShippingBars.forEach(async (bar) => {
        if (!bar) return;
        await bar.fetchCartData();
        bar.dataset.cartTotal = cartData.total_price;

        if (hasFreteCoupon) {
          bar.setAttribute("data-free-shipping", "true");
          if (typeof bar.setFreeShipping === "function") {
            bar.setFreeShipping();
          }
          if (typeof bar.updateStatus === "function") {
            bar.updateStatus();
          }
        } else {
          bar.removeAttribute("data-free-shipping");
          if (typeof bar.resetFreeShipping === "function") {
            bar.resetFreeShipping();
          }
          if (typeof bar.updateStatus === "function") {
            bar.updateStatus();
          }
        }
      });

      // Progress bar custom (container_progressbar) — reutiliza a mesma lógica do cart.js
      const progressContainer = document.querySelector(".container_progressbar");
      if (progressContainer && typeof window.setShippingProgressBar === "function") {
        window.setShippingProgressBar(progressContainer, cartData);
      }
    }

    function showMsg(message, type) {
      const msgEl = document.querySelector(".discount-coupon__message");
      if (!msgEl) return;
      const p = msgEl.querySelector(".form__message");
      if (!p) return;
      p.innerHTML = message;
      p.style.color =
        type === "error" ? "red" : type === "success" ? "green" : "inherit";
      msgEl.style.display = "block";
      setTimeout(() => {
        msgEl.style.display = "none";
      }, 3000);
      window._lastDiscountCouponMsg = { message, type };
    }

    if (!window._discountCouponDelegatedListenersAdded) {
      window._discountCouponDelegatedListenersAdded = true;
      document.addEventListener(
        "submit",
        function (e) {
          if (e.target && e.target.id === "discount-coupon-form") {
            console.log("form submit event fired (delegated)");
            e.preventDefault();
            e.stopPropagation();
            applyCoupon();
            return false;
          }
        },
        true,
      );

      document.addEventListener(
        "click",
        function (e) {
          if (e.target && e.target.id === "discount-coupon-btn") {
            console.log("button click event fired (delegated)");
            e.preventDefault();
            e.stopPropagation();
            applyCoupon();
            return false;
          }
          const removeBtn =
            e.target.closest && e.target.closest(".remove-coupon");
          if (removeBtn) {
            console.log("remove coupon click event fired (delegated)");
            e.preventDefault();
            e.stopPropagation();
            const coupon = removeBtn.dataset.coupon;
            removeCoupon(coupon);
            return false;
          }
        },
        true,
      );

      document.addEventListener(
        "keydown",
        function (e) {
          if (
            e.target &&
            e.target.id === "discount-coupon-input" &&
            e.key === "Enter"
          ) {
            console.log("input enter key event fired (delegated)");
            e.preventDefault();
            e.stopPropagation();
            applyCoupon();
            return false;
          }
        },
        true,
      );
    }

    fetchAppliedCoupon();
    updateCartSummary();

    setTimeout(async () => {
      const res = await fetch("/cart.js");
      const data = await res.json();
      updateFreeShippingBar(data);
    }, 500);

    document.addEventListener("cart:updated", function () {
      setTimeout(() => {
        fetchAppliedCoupon();
        updateCartSummary();
      }, 200);
    });

    document.addEventListener("cart:drawer-refreshed", function () {
      setTimeout(() => {
        fetchAppliedCoupon();
        updateCartSummary();
      }, 200);
    });

    let couponDrawerObserver = null;
    let couponDrawerTimeout = null;

    function observeDrawer() {
      const drawer = document.querySelector("#CartDrawer");
      if (!drawer) return;

      if (couponDrawerObserver) {
        couponDrawerObserver.disconnect();
      }

      couponDrawerObserver = new MutationObserver(function (mutations) {
        const drawerContentChanged = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some(
            (node) =>
              node.nodeType === 1 &&
              (node.classList?.contains("discount-coupon__list") ||
                node.classList?.contains("drawer__inner") ||
                node.querySelector?.(".discount-coupon__list")),
          ),
        );
        if (!drawerContentChanged) return;

        clearTimeout(couponDrawerTimeout);
        couponDrawerTimeout = setTimeout(async () => {
          await fetchAppliedCoupon();
          const res = await fetch("/cart.js");
          const data = await res.json();
          updateFreeShippingBar(data);
        }, 300);
      });

      couponDrawerObserver.observe(drawer, {
        childList: true,
        subtree: true,
      });
    }

    observeDrawer();

    const bodyObserver = new MutationObserver(function () {
      observeDrawer();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  async function syncCouponStateOnPageRestore() {
    try {
      const res = await fetch("/cart.js", {
        cache: "no-store",
        headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
      });
      const data = await res.json();
      const discountCodes = data.discount_codes || [];
      const applicableCodes = discountCodes
        .filter((dc) => dc.applicable)
        .map((dc) => dc.code.toUpperCase());

      if (applicableCodes.length === 0) {
        const discountElements = document.querySelectorAll(
          ".discounts__discount--end, .discounts__discount--position",
        );
        discountElements.forEach((el) => el.remove());
      }

      const lists = document.querySelectorAll(".discount-coupon__list");
      lists.forEach((list) => {
        list.innerHTML = "";
        applicableCodes.forEach((code) => {
          const couponEl = document.createElement("div");
          couponEl.className = "cart-coupon-applied";
          couponEl.setAttribute("data-discount-code", code);

          const textEl = document.createElement("span");
          textEl.className = "cart-coupon-applied-text";
          textEl.textContent = code;

          const removeBtn = document.createElement("button");
          removeBtn.type = "button";
          removeBtn.className = "cart-coupon-remove";
          removeBtn.setAttribute("aria-label", "Remover cupom");
          removeBtn.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="var(--icon-stroke-width)" stroke="currentColor" class="icon icon-close"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>';

          removeBtn.addEventListener("click", async function (e) {
            e.preventDefault();
            e.stopPropagation();
            removeBtn.disabled = true;
            removeBtn.classList.add("loading");
            try {
              const currentRes = await fetch("/cart.js");
              const currentData = await currentRes.json();
              const currentCoupons = (currentData.discount_codes || []).map(
                (dc) => dc.code.toUpperCase(),
              );
              const remainingCoupons = currentCoupons.filter(
                (c) => c.toUpperCase() !== code.toUpperCase(),
              );

              await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({ discount: "" }),
              });
              if (remainingCoupons.length > 0) {
                await fetch("/cart/update.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({
                    discount: remainingCoupons.join(","),
                  }),
                });
              }
              await syncCouponStateOnPageRestore();
              document.dispatchEvent(new CustomEvent("cart:updated"));
            } catch (err) {
              console.error("Erro ao remover cupom:", err);
            } finally {
              removeBtn.disabled = false;
              removeBtn.classList.remove("loading");
            }
          });

          couponEl.appendChild(textEl);
          couponEl.appendChild(removeBtn);
          list.appendChild(couponEl);
        });
      });

      const drawerTotalEl = document.querySelector(
        "#CartDrawer .totals__total-value",
      );
      if (drawerTotalEl) {
        drawerTotalEl.textContent = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(data.total_price / 100);
      }
      const pageTotalEls = document.querySelectorAll(".totals__total-value");
      pageTotalEls.forEach((el) => {
        if (el.closest("#main-cart-footer") || el.closest(".cart__footer")) {
          el.textContent = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(data.total_price / 100);
        }
      });

      const discountTotalEl = document.querySelector(
        ".totals__total-value--discount",
      );
      if (discountTotalEl) {
        const comparedPrice = parseInt(
          discountTotalEl.getAttribute("data-compared-price") || "0",
        );
        let totalDiscount = comparedPrice - data.total_price;
        const discountContainer = discountTotalEl.closest(".totals");
        if (totalDiscount > 0) {
          discountTotalEl.textContent = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(totalDiscount / 100);
          if (discountContainer) discountContainer.style.display = "";
        } else {
          discountTotalEl.textContent = "";
          if (discountContainer) discountContainer.style.display = "none";
        }
      }

      if (window.updateProgressBar) {
        window.updateProgressBar();
      }
    } catch (e) {
      console.error("Error syncing coupon state:", e);
    }
  }

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      syncCouponStateOnPageRestore();
    } else {
      syncCouponStateOnPageRestore();
    }
  });

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      syncCouponStateOnPageRestore();
    }
  });

  window.addEventListener("focus", function () {
    syncCouponStateOnPageRestore();
  });

  window.addEventListener("popstate", function () {
    syncCouponStateOnPageRestore();
  });

  if (document.referrer.includes("/checkout")) {
    syncCouponStateOnPageRestore();
  }

  document.addEventListener("DOMContentLoaded", initCouponScript);
})();
